import { ToastsStore } from 'react-toasts';

const toMessage = (err, fallback) => {
  if (typeof err === 'string') return err;
  if (err && typeof err === 'object') {
    return err.message || err.error || fallback;
  }
  return fallback;
};

export const notifyError = (err, fallback = 'Ocorreu um erro inesperado.') => {
  ToastsStore.error(toMessage(err, fallback));
};

export const notifySuccess = (message) => {
  ToastsStore.success(message);
};

export const notifyWarning = (message) => {
  ToastsStore.warning(message);
};

export const notifyInfo = (message) => {
  ToastsStore.info(message);
};
